import { getEditDefaultActionsData, getPreviewDefaultActionsData, getPrimaryDefaultActionsData, getRemoveDefaultActionsData } from '../default/getDefaultChickletHoverActions';
import { CONTACT_TYPE_ID, DEAL_TYPE_ID, LEAD_TYPE_ID, PARTNER_CLIENT_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';

/**
 * Determines whether to show the primary association action and returns the appropriate data
 */
import { jsx as _jsx } from "react/jsx-runtime";
const getPrimaryAssociationActionData = args => {
  const {
    associatedObjectsIds,
    fromObjectTypeId,
    primaryAssociationObjectId
  } = args;
  const primaryDefaultActionsData = getPrimaryDefaultActionsData(args);
  if (!primaryDefaultActionsData) {
    return undefined;
  }

  // If there is only one associated company and it's already primary
  // the Remove as Primary button shouldn't show
  switch (fromObjectTypeId) {
    case CONTACT_TYPE_ID:
    case TICKET_TYPE_ID:
    case DEAL_TYPE_ID:
    case PARTNER_CLIENT_TYPE_ID:
      if (!!primaryAssociationObjectId && associatedObjectsIds.length === 1) {
        return undefined;
      }
      return primaryDefaultActionsData;
    default:
      return primaryDefaultActionsData;
  }
};

/**
 * Determines whether to show the edit association labels action and returns the appropriate data
 */
const getEditAssociationActionData = args => {
  const {
    fromObjectTypeId
  } = args;
  switch (fromObjectTypeId) {
    case LEAD_TYPE_ID:
      return undefined;
    default:
      return getEditDefaultActionsData(args);
  }
};

/**
 * Determines whether to disable the remove association action and returns the appropriate data
 */
const getRemoveAssociationActionData = args => {
  const {
    fromObjectTypeId,
    objectId,
    primaryAssociationObjectId
  } = args;
  switch (fromObjectTypeId) {
    case LEAD_TYPE_ID:
      if (objectId === primaryAssociationObjectId) {
        return getRemoveDefaultActionsData(args, {
          disabled: true,
          disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.disabledRemovePrimaryCompanyAssociationFromLeadTooltip"
          })
        });
      }
      return getRemoveDefaultActionsData(args);
    default:
      return getRemoveDefaultActionsData(args);
  }
};
const useActions = args => {
  return {
    PrimaryAction: getPreviewDefaultActionsData(args),
    SecondaryActions: [getPrimaryAssociationActionData(args), getEditAssociationActionData(args), getRemoveAssociationActionData(args)]
  };
};
export default useActions;